import { ContactFiltersData } from "@assets/mocks/filterData";
import { useNavigate } from "react-router";

interface Props {
  id: number;
}

import icon1 from "../../../../../assets/icons/contactIcons/contact location.png"
import icon2 from "../../../../../assets/icons/contactIcons/department hierarchy.png"
import icon3 from "../../../../../assets/icons/contactIcons/job title search.png"
import icon4 from "../../../../../assets/icons/contactIcons/profile completenes.png"

const ContactFilters:React.FC<Props> = ({id}) => {
  const navigate = useNavigate();


  const iconList = [

    {
      src: icon2,
      alt: "Department Hierarchy",
      label: "Department Hierarchy",
    },
    {
      src: icon3,
      alt: "Job Title Search",
      label: "Job Title Search",
    },
    {
      src: icon1,
      alt: "Contact Location",
      label: "Contact Location",
    },
   
 
    {
      src: icon4,
      alt: "Profile Completeness",
      label: "Profile Completeness",
    },
  ];
  
  // ContactFilters
  console.log("Hey I am here")
  console.log(ContactFilters)

  return (
    <div className="w-2/3">
      
      <div className="flex flex-wrap gap-5">
        {ContactFiltersData.map((val, index) => {
          return (
            <div
              className="bg-white flex justify-center items-center text-center px-4 flex-col h-52 rounded-lg w-1/3 cursor-pointer"
              onClick={() => navigate(`/targetMarkets/targetMarketDetail/${id}/?filter=${val.path}`)}
            >
              <img src={iconList[index].src} alt="" className="h-[45px]" />
              <h6 className="text-gray text-lg font-medium pt-2 pb-3">
                {val.title}
              </h6>
              <p className="text-[#71717A] text-sm">{val.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContactFilters;
